export const JOURNEY_PARAMS = "COMMON/JOURNEY_PARAMS"
export const FOOTER_DATA = "COMMON/FOOTER_DATA";
export const HOME_PAGE_CONTENT = "HOME_PAGE_CONTENT";
export const INSERT_ROUTE_STATE= "INSERT_ROUTE_STATE";